// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-box {
  background: rgba(255, 255, 255, 0.1);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 20px;
  width: 320px;
  max-width: 90%;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  color: white;
  font-family: "Arial", sans-serif;
  position: relative;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 10px;
}
.popup-header h2 {
  font-size: 24px;
  font-weight: bold;
}
.popup-header .close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  transition: color 0.2s;
}
.popup-header .close-btn:hover {
  color: #ffdd00;
}

.popup-content {
  list-style-type: none;
  padding: 0;
  margin: 20px 0;
}
.popup-content li {
  display: flex;
  align-items: center;
  font-size: 16px;
  margin-bottom: 10px;
  font-weight: 500;
}
.popup-content .icon {
  font-size: 20px;
  margin-right: 10px;
  color: #ffdd00;
}

.popup-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.popup-footer .subscribe-btn {
  background-color: transparent;
  border: 2px solid #ffdd00;
  color: #ffdd00;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 25px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}
.popup-footer .subscribe-btn:hover {
  background-color: #ffdd00;
  color: black;
}
.popup-footer .billing-info {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/SubscriptionPopup/SubscriptionPopup.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AACJ;;AAEE;EACE,oCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,yCAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;AACJ;;AAEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iDAAA;EACA,oBAAA;AACJ;AACI;EACE,eAAA;EACA,iBAAA;AACN;AAEI;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;AAAN;AAEM;EACE,cAAA;AAAR;;AAKE;EACE,qBAAA;EACA,UAAA;EACA,cAAA;AAFJ;AAII;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAFN;AAKI;EACE,eAAA;EACA,kBAAA;EACA,cAAA;AAHN;;AAOE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAJJ;AAMI;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,6CAAA;AAJN;AAMM;EACE,yBAAA;EACA,YAAA;AAJR;AAQI;EACE,eAAA;EACA,+BAAA;EACA,eAAA;AANN","sourcesContent":[".popup-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5); // Dark overlay background\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n  \n  .popup-box {\n    background: rgba(255, 255, 255, 0.1);\n    backdrop-filter: blur(10px);\n    border-radius: 16px;\n    padding: 20px;\n    width: 320px;\n    max-width: 90%;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n    color: white;\n    font-family: 'Arial', sans-serif;\n    position: relative;\n  }\n  \n  .popup-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n    padding-bottom: 10px;\n  \n    h2 {\n      font-size: 24px;\n      font-weight: bold;\n    }\n  \n    .close-btn {\n      background: none;\n      border: none;\n      color: white;\n      font-size: 20px;\n      cursor: pointer;\n      transition: color 0.2s;\n  \n      &:hover {\n        color: #ffdd00;\n      }\n    }\n  }\n  \n  .popup-content {\n    list-style-type: none;\n    padding: 0;\n    margin: 20px 0;\n  \n    li {\n      display: flex;\n      align-items: center;\n      font-size: 16px;\n      margin-bottom: 10px;\n      font-weight: 500;\n    }\n  \n    .icon {\n      font-size: 20px;\n      margin-right: 10px;\n      color: #ffdd00;\n    }\n  }\n  \n  .popup-footer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  \n    .subscribe-btn {\n      background-color: transparent;\n      border: 2px solid #ffdd00;\n      color: #ffdd00;\n      padding: 10px 20px;\n      font-size: 16px;\n      font-weight: bold;\n      border-radius: 25px;\n      cursor: pointer;\n      transition: background-color 0.3s, color 0.3s;\n  \n      &:hover {\n        background-color: #ffdd00;\n        color: black;\n      }\n    }\n  \n    .billing-info {\n      font-size: 12px;\n      color: rgba(255, 255, 255, 0.7);\n      margin-top: 8px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
